/* eslint-disable lingui/no-unlocalized-strings */
export const USDateViewFormat = 'M/D/YYYY';
export const USDateTimeViewFormat = 'M/D/YYYY HH:mm';
export const DateISOFormat = 'YYYY-MM-DD';
export const MonthDateYearFormat = 'MMM D, YYYY';
export const MonthDateFormat = 'MMM D';
export const MonthDateShortFormat = 'M/D';
